import { searchAddressByZipCode } from '../services/searchAddressByZipCode'
import { japanPrefecturesAsArrayOfKeyedObject, japanPrefecturesKeyedObject } from '../services/formConsts'
import { isValidZipCode } from './signup'
import { ColumnDef } from '@shared/model'

interface Columns {
  [colName: string]: ColumnDef
}

export const axGenderValueMap = {
  man: '男性',
  woman: '女性',
  other: 'その他',
}

export const isNameKana = (str,name) => {
  if(!str.match('^[ァ-ヶｱ-ﾝﾞﾟ]*$')){
    return name + 'は全角カタカナで入力してください。'
  }
}

// パスワードチェック
export const passwordValidator = (value) => {
  // パスワードのRule
  const low_case = /[a-z]/
  const upper_case = /[A-Z]/
  const number = /[0-9]/
  const isValid =
  low_case.test(value) && upper_case.test(value) && number.test(value) && value.length >= 8 && value.length <= 32
    if (!isValid) {
      return '8文字以上32文字以下の半角英大文字、小文字、数字混在、それぞれ必ず1文字を入れて入力してください。'
    }
  }

// パスワード不一致チェック
export const sameWithPassword = (password_confirm, password) => {
  if (password_confirm !== password) {
    return 'パスワードが一致しません。もう一度正しく入力してください'
  }
}

// 電話番号桁数チェック
export const telValidator = (value) => {
  if (value.length != 10 && value.length != 11) {
    return '10桁または11桁でご入力ください。'
  }
  return
}

//　数字がチェック
export const is_int = (value,name) => {
  const int = /[0-9]/
  const isValid = int.test(value)
  if(!isValid){
    return name + 'を入力してください'
  }
}

// 入力した値が空かチェック　フリガナ以外
export const isNotEmpty = (value,name) => {
  const str = value.toString()
  if(str.match(/^[\s\t\r\n]*$/)){
    return name + 'を入力してください'
  }
}

// 入力した値が空かチェック フリガナのみ
export const isNotEmptyKana = (value,name) => {
  const str = value.toString()
  if(str.match(/^[\s\t\r\n]*$/)){
    return name  + 'は全角カタカナで入力してください'
  }
}

export const isNotEmptyPassword = (value) => {
  const str = value.toString()
  if(str.match(/^[\s\t\r\n]*$/)){
    return 'を入力してください'
  }
}

// メール
export const is_email = (value,name) => {
  if(!value.match("^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$")){
    return name + 'を入力してください'
  }
}

// 郵便
export const isZipcode = (value,name) => {
   const isValid = /^\d+$/.test(value) === true && value.length === 7
   if(!isValid){
    return '郵便番号は7桁の数字のみで正しく入力してください(ハイフンなし)'
   }
}

// 都道府県
export const isNotEmptySelect = (value,name) => {
  const str = value.toString()
  if(str.match(/^[\s\t\r\n]*$/)){
    return name + 'を選択してください'
  }
}

// 市町村　文字制限
export const is_city_length = (value,name) => {
  const isValid =
    value.length <= 40
  if (!isValid) {
    return name + 'は40文字以内で入力してください'
  }
}

export const userColumns: Columns = {
  id: {
    type: 'STRING',
    visible: false,
  },

  family_name:{
    type: 'STRING',
    label: 'お名前（姓）',
    inputAttrs: { wrapperClass: 'col-12', style: 'width: 100px;' },
    validate: { isNotEmpty },
  },

  reputation:{
    type: 'STRING',
    label: 'お名前（名）',
    inputAttrs: { wrapperClass: 'col-12', style: 'width: 100px;' },
    validate: { isNotEmpty },
  },

  family_name_kana:{
    type: 'STRING',
    label: 'フリガナ（セイ）',
    inputAttrs: { wrapperClass: 'col-12', style: 'width: 100px;' },
    validate: { isNotEmptyKana,isNameKana  },
  },
  reputation_kana:{
    type: 'STRING',
    label: 'フリガナ（メイ）',
    inputAttrs: { wrapperClass: 'col-12', style: 'width: 100px;' },
    validate: { isNotEmptyKana,isNameKana  },
  },
  zip: {
    label: '郵便番号',
    type: 'STRING',
    inputAttrs: {
      class: 'text-left',
      wrapperClass: 'col-12',
      style: 'max-width: 180px;',
    },
    validate: {
      isNotEmpty,
      isZipcode
    },
    inputHelpText: '郵便番号がわからない方',
    editCallback: async ({ row, newValue, oldValue, isNewRecord }) => {
      if (newValue && newValue !== oldValue && isValidZipCode(newValue)) {
        try {
          const zipRes = await searchAddressByZipCode(newValue)
          if (zipRes && zipRes.prefCode) {
            // 文字列にしておかないとAX側で保存されないっぽい
            row.state =
              japanPrefecturesAsArrayOfKeyedObject.find((pr) => pr.label === zipRes.prefName)?.key.toString() || ''
            row.city = zipRes.city
            row.street = zipRes.street
          }
        } catch (e) {
          // 必要であればハンドリングを入れてください
        }
      }
      return row
    },
  },
  state: {
    type: 'STRING',
    label: '都道府県',
    validate: { isNotEmptySelect },
    selections: () => Object.keys(japanPrefecturesKeyedObject).map((code) => `${code}`),
    strictSelections: true,
    customLabel: (prefCode) => japanPrefecturesKeyedObject[prefCode],
    inputAttrs: { wrapperClass: 'col-12', style: 'max-width: 120px;' },
  },
  city: {
    type: 'STRING',
    label: '市区郡町村',
    validate: { isNotEmpty,is_city_length },
    inputAttrs: { wrapperClass: 'col-12', style: 'max-width: 340px;' },
  },
  street: {
    type: 'STRING',
    label: '町域番地',
    validate: { isNotEmpty },
    inputAttrs: { wrapperClass: 'col-12', style: 'max-width: 340px;' },
    inputHelpText: '※市区郡町村名より後ろの住所を入力してください。',
  },
  building: {
    type: 'STRING',
    label: 'アパート・マンション名・部屋番号',
    inputAttrs: { wrapperClass: 'col-12', style: 'max-width: 340px;' },
    inputHelpText: '※建物名がある場合は入力してください',
  },
  tel_number1: {
    type: 'STRING',
    label: '電話番号',
    validate: {
      isNotEmpty,
      is_int
    },
    inputAttrs: {
      wrapperClass: 'col-12',
      style: 'width: 100px;',
      class: 'text-left',
    },
  },
  tel_number2: {
    type: 'STRING',
    label: '電話番号',
    validate: {
      isNotEmpty,
      is_int
    },
    inputAttrs: {
      wrapperClass: 'col-12',
      style: 'width: 100px;',
      class: 'text-left',
    },
  },
  tel_number3: {
    type: 'STRING',
    label: '電話番号',
    validate: {
      isNotEmpty,
      is_int
    },
    inputAttrs: {
      wrapperClass: 'col-12',
      style: 'width: 100px;',
      class: 'text-left',
    },
  },
  gender: {
    type: 'STRING',
    label: '性別',
    inputAttrs: {
      radio: true,
    },
    validate: { isNotEmptySelect },
    selections () {
      return [
        { text: '男性', value: "man"},
        { text: '女性', value: "woman" },
      ]
    },
  },
  birthday_y: {
    type: 'STRING',
    label: '生年月日 (年)',
    validate: { isNotEmptySelect },
    strictSelections: true,
    selections: () => {
      const yearCounts = 110
      const years = []
      const currentYear = new Date().getFullYear()
      for (let i = 0; yearCounts >= i; i++) {
        years.push(currentYear - (yearCounts - i))
      }
      return years
    },
    default_select_scroll_to_value: 2000,
  },
  birthday_m: {
    type: 'STRING',
    label: '生年月日 (月)',
    validate: { isNotEmptySelect },
    strictSelections: true,
    selections: () => [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    inputHelpText: '月',
  },
  birthday_d: {
    type: 'STRING',
    label: '生年月日 (日)',
    validate: { isNotEmptySelect },
    strictSelections: true,
    selections: () => {
      const counts = 31
      const days = []
      for (let i = 1; counts >= i; i++) {
        days.push(i)
      }
      return days
    },
    inputHelpText: '日',
  },
  email: {
    type: 'STRING',
    label: 'メールアドレス',
    inputAttrs: { wrapperClass: 'col-12', style: 'max-width: 280px;' },
    validate: { isNotEmpty,is_email},
  },
  accept_makerepeater_mail: {
    type: 'BOOLEAN',
    label: 'メール配信',
    default:true,
  },
  password: {
    type: 'STRING',
    label: 'パスワード',
    inputAttrs: { wrapperClass: 'col-12', style: 'max-width: 280px;', type: 'password' },
    validate: {
      isNotEmptyPassword,
      passwordValidator
    },
  },
  password_confirm: {
    type: 'STRING',
    label: 'パスワード (確認)',
    inputAttrs: { wrapperClass: 'col-12', style: 'max-width: 280px;', type: 'password' },
    validate: {
      isNotEmptyPassword,
      sameWithPassword,
      passwordValidator,
    },
  },

  socialPlusToken: {
    type: 'STRING',
    visible: false,
  },
  socialPlusUserId: {
    type: 'STRING',
    visible: false,
  },
  snsType: {
    type: 'STRING',
    visible: false,
  },
  goToNext:{
    type: 'BOOLEAN',
    visible:false,
  }
}

